import createAdNetworkUISignalNameBuilder from "app/pages/sales-intelligence/sub-modules/signals/services/ui-signals/ad-network/adNetworkUISignalNameBuilder";

import type AdNetworkSignalFilters from "../../../models/ad-network/AdNetworkSignalFilters";
import type UISignal from "../../../models/view/UISignal";
import type UISignalDeps from "../../../models/view/UISignalDeps";
import type UISignalFactory from "../UISignalFactory";

const adNetworkUISignalFactory: UISignalFactory<AdNetworkSignalFilters> = {
    createUISignal(deps: Readonly<UISignalDeps<AdNetworkSignalFilters>>): Readonly<UISignal<AdNetworkSignalFilters>> {
        const {
            adNetworks,
            numberOfAccounts,
            signal,
            template: { alias, description, name, signalSubType, timeframeConfig },
        } = deps;

        const nameBuilder = createAdNetworkUISignalNameBuilder({
            adNetworks,
        });

        return {
            ...signal,
            numberOfAccounts,
            signalSubType,
            timeframeConfig,
            template: { alias, description, name },
            name: nameBuilder.buildName(signal),
            nameSegments: nameBuilder.buildNameSegments(signal),
            selectionTooltipLabels: nameBuilder.buildSelectionTooltipLabels(signal),
        };
    },
};

export default adNetworkUISignalFactory;
